import { Component, OnInit } from '@angular/core';

@Component({ selector: 'app-submit', templateUrl: './submit.component.html', styleUrls: ['./submit.component.scss'] })
export class SubmitComponent implements OnInit { constructor() { } ngOnInit(): void { } }
